import auth from './auth';
import branch from './branch';
import commercial from './commercial';
import event from './event';
import loader from './loader';
import snackbar from './snackbar';
import files from './files';
import member from './member';
import ui from './ui';

export default {
  auth,
  branch,
  commercial,
  event,
  loader,
  snackbar,
  files,
  member,
  ui,
};
